import { render, staticRenderFns } from "./ModulePrecursor.vue?vue&type=template&id=4ba5b5f0"
import script from "./ModulePrecursor.vue?vue&type=script&lang=js"
export * from "./ModulePrecursor.vue?vue&type=script&lang=js"
import style0 from "./ModulePrecursor.vue?vue&type=style&index=0&id=4ba5b5f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports